import { render, staticRenderFns } from "./ResultsPanel.vue?vue&type=template&id=1087cded&scoped=true"
import script from "./ResultsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultsPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./wellness-base.css?vue&type=style&index=0&id=1087cded&prod&scoped=true&lang=css&external"
import style1 from "./ResultsPanel.vue?vue&type=style&index=1&id=1087cded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087cded",
  null
  
)

export default component.exports